import CtaButton from './CtaButton';
import { openSalesIQChat } from '../utils/openSalesIQChat';
import './Troubleshooting.css';

const SUPPORT_IMG = '/images/troubleshooting.jpg';

const problems = [
  'Slow or interrupted internet connection during download.',
  'Insufficient storage space on the GPS or memory card.',
  'Outdated device software or firmware blocking new maps.',
  'Loose or incompatible USB cable connection.',
  'Wrong map region or license selected during purchase.',
  'Computer firewall or antivirus interrupting the update tool.',
  'Device battery too low to complete installation.',
  'Corrupted previous map files causing install failure.',
  'Unsupported operating system on the connected computer.',
  'Account login or activation issues with the map provider.',
];

export default function Troubleshooting() {
  return (
    <section className="section troubleshooting" id="support">
      <div className="container troubleshooting-grid">
        <div className="troubleshooting-image">
          <img src={SUPPORT_IMG} alt="GPS map update support specialist ready to help" loading="lazy" />
        </div>
        <div>
          <h2 className="section-title">Problems Faced While Updating Maps</h2>
          <p className="section-lead">
            Map updates can fail for many common reasons. Review the list below — then request help if you are stuck.
          </p>
          <ol className="problem-list">
            {problems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
          <p className="troubleshooting-note">
            Our support team can help diagnose connection, storage, and compatibility issues for your specific GPS model.
          </p>
          <div className="troubleshooting-actions">
            <CtaButton className="btn btn-primary">Get Troubleshooting Help</CtaButton>
            <button type="button" className="btn btn-outline" onClick={openSalesIQChat}>
              Chat Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
